import { useState, useEffect } from "react";
import { Row, Col, Tabs, Dropdown, Menu } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
} from "@ant-design/icons";

import DataTable from "../../DataTable";
import CopyableCell from "../../CopyableCell";

const { TabPane } = Tabs;

interface IProductProps {
  customers: any;
  showEditModal: Function;
  handleDelete: Function;
  filtered: any;
}

const FuneralCustomerTable: React.FC<IProductProps> = ({
  customers,
  showEditModal,
  handleDelete,
  filtered,
}) => {
  const [active, setActive] = useState([]); //All Tab
  const [inactive, setInactive] = useState([]); //Cancelled Tab

  const [filteredActive, setFilteredActive] = useState([]); //Active Tab
  const [filteredInActive, setFilteredInActive] = useState([]); //Active Tab

  const [state, setState] = useState({
    loading: true,
    activeKey: sessionStorage.getItem("funeralCustomersActiveTab") || "1",
    pagination: {
      pageSize: 15,
      position: ["bottomRight"],
      total: 0,
      current: Number(sessionStorage.getItem("funeralCustomersPage")) || 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const fetchActive = async (params = {}) => {
    try {
      const active = customers.filter(
        (item: any) => item.Status.Status === "Active"
      );

      if (filtered.length > 0) {
        const activeFiltered = filtered.filter(
          (item: any) => item.Status.Status === "Active"
        );
        setFilteredActive(activeFiltered);
      }

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });

      setActive(active);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchInActive = async (params = {}) => {
    try {
      const inactive = customers.filter(
        (item: any) => item.Status.Status === "Inactive"
      );

      if (filtered.length > 0) {
        const inActiveFiltered = filtered.filter(
          (item: any) => item.Status.Status === "Inactive"
        );
        setFilteredInActive(inActiveFiltered);
      }

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });
      setInactive(inactive);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (filtered.length === 0) {
      setFilteredActive([]);
      setFilteredInActive([]);
    }
    fetchActive();
    fetchInActive();
  }, [customers, filtered]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const pager = { ...state.pagination };
    pager.current = pagination.current;
    sessionStorage.setItem("funeralCustomersPage", String(pagination.current));
    setState({
      ...state,
      pagination: pager,
    });

    const params = {
      pageSize: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    };

    fetchActive(params);
  };

  const columns = [
    {
      title: "Customer ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Surname",
      dataIndex: "Surname",
      sorter: (a: any, b: any) => a.Surname.localeCompare(b.Surname),
    },
    {
      title: "ID Number",
      dataIndex: "IdNumber",
      render: (v: any) => <CopyableCell value={v} />,
    },
    {
      title: "Cellphone",
      dataIndex: "Cellphone",
    },
    {
      dataIndex: "Action",
      render: (_: any, record: any) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="edit"
                icon={<EditOutlined style={{ color: "blue" }} />}
                onClick={() => showEditModal(record)}
              >
                Edit Customer
              </Menu.Item>
              <Menu.Item
                key="remove"
                icon={<DeleteOutlined style={{ color: "red" }} />}
                onClick={() => handleDelete(record.id, state.activeKey)}
              >
                Remove Customer
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <MoreOutlined
            rotate={90}
            style={{ cursor: "pointer", fontSize: "16px", color: "#000" }}
          />
        </Dropdown>
      ),
    },
  ];

  const tabPanes = [
    {
      key: "1",
      title: "Active",
      content: (
        <DataTable
          persistKey="funeral-customers"
          dataSource={filteredActive.length > 0 ? filteredActive : active}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: filteredActive.length > 0 ? filteredActive.length : active.length,
    },
    {
      key: "2",
      title: "Inactive",
      content: (
        <DataTable
          persistKey="funeral-customers"
          dataSource={filteredInActive.length > 0 ? filteredInActive : inactive}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count:
        filteredInActive.length > 0 ? filteredInActive.length : inactive.length,
    },
  ];

  const changeTab = (key: any) => {
    const pagination = { ...state.pagination, current: 1 };
    sessionStorage.setItem("funeralCustomersActiveTab", key);
    sessionStorage.setItem("funeralCustomersPage", "1");
    setState({
      ...state,
      activeKey: key,
      loading: false,
      pagination,
    });
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Tabs
            type="card"
            defaultActiveKey={state.activeKey}
            activeKey={state.activeKey}
            onChange={changeTab}
          >
            {tabPanes.map((pane) => (
              <TabPane
                key={pane.key}
                tab={
                  <>
                    <span>{pane.title}</span>
                    <span
                      style={{
                        color: "#B0B0B0",
                        fontWeight: "300",
                        marginLeft: "3px",
                        fontSize: "12px",
                      }}
                    >
                      ({pane.count})
                    </span>
                  </>
                }
              >
                {pane.content}
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default FuneralCustomerTable;
